import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import Client7 from "../assets/Client7.png";

export default function ClientsSection() {
  const clients = [
    { id: 7, img: Client7, alt: "Client 7" },
    // You can easily add more clients here later...
  ];

  return (
    <Box
      sx={{
        py: { xs: 10, md: 14 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative Blur Circles */}
      <Box
        sx={{
          position: "absolute",
          top: "-60px",
          left: "-80px",
          width: 200,
          height: 200,
          borderRadius: "50%",
                zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "-60px",
          right: "-80px",
          width: 250,
          height: 250,
          borderRadius: "50%",
          background:
            "radial-gradient(circle at center, rgba(0,75,160,0.1), transparent 70%)",
          zIndex: 0,
        }}
      />

      <Container sx={{ textAlign: "center", position: "relative", zIndex: 2 }}>
        {/* === Header === */}
        <Typography
          variant="h4"
          fontWeight={800}
          mb={2}
          sx={{
            background: "linear-gradient(90deg, #1565c0, #004ba0)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Our Esteemed Clients
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          maxWidth="800px"
          mx="auto"
          mb={8}
          sx={{ fontSize: "1.05rem", lineHeight: 1.8 }}
        >
          Over the years, we’ve had the privilege of partnering with some of
          India’s most respected organizations, institutions, and enterprises.
          Our clients trust us for our commitment to excellence, transparent
          processes, and timely execution. We take pride in building
          relationships that go beyond service — we deliver reliability,
          innovation, and a partnership that helps them achieve their goals
          seamlessly.
        </Typography>

        {/* === Client Logos === */}
        <Grid
          container
          spacing={{ xs: 4, sm: 6, md: 8 }}
          justifyContent="center"
          alignItems="center"
        >
          {clients.map((client) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              key={client.id}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "white",
                  p: 3,
                  borderRadius: 4,
                  boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                  transition:
                    "transform 0.4s ease, box-shadow 0.4s ease, opacity 0.4s ease",
                  "&:hover": {
                    transform: "translateY(-6px) scale(1.05)",
                    boxShadow: "0 6px 20px rgba(21,101,192,0.15)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={client.img}
                  alt={client.alt}
                  sx={{
                    width: { xs: "70%", sm: "65%", md: "75%" },
                    maxWidth: 220,
                    opacity: 0.9,
                    transition: "opacity 0.4s ease",
                    "&:hover": {
                      opacity: 1,
                    },
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* === Closing Line === */}
        <Typography
          variant="h6"
          color="primary"
          mt={10}
          fontWeight={600}
          sx={{
            opacity: 0.85,
          }}
        >
          Building trust through excellence — one client at a time.
        </Typography>
      </Container>
    </Box>
  );
}
